module.exports = __webpack_public_path__ + "img/求生者.60548add.png";